import Helmet from "react-helmet";

export default function FontHelmet({ community }) {
  const fontLink = community?.configurables?.COMMUNITY_DEFAULT_FONT_LINK ?? "";
  const fontFamily =
    community?.configurables?.COMMUNITY_DEFAULT_FONT_NAME ?? "";

  return (
    <Helmet
      style={[
        {
          cssText: `
            body {
                font-family: ${
                  fontFamily ? `"${fontFamily}", ` : ""
                }"Nunito", sans-serif !important; ;
            }
        `,
        },
      ]}>
      {fontLink ? <link href={encodeURI(fontLink)} rel="stylesheet" /> : ""}
    </Helmet>
  );
}
